<template>
  <div>
    <!-- Loader -->
    <div v-if="initialLoad" style="background-color: #F5F7FA; height: 100vh; display: flex; align-items: center; justify-content: center;">
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          size="50"
        ></v-progress-circular>
        <div class="mt-4 text-body-1">Memuat Dashboard...</div>
      </div>
        </div>

    <!-- Dashboard Content -->
    <div v-else style="background-color: #ffffff;" class="ma-2 mt-7">
      <div class="pa-4">
      <!-- Breadcrumb & Date Filter -->
      <div class="d-flex justify-space-between align-center mb-0">
        <div>
          <span class="fs-18 black--text">Dashboard Mitra Warung</span>
        </div>
        <date-filter @change="handleDateChange" />
      </div>

      <!-- Top Stats Cards -->
      <v-row class="mb-0">
        <v-col cols="12" sm="6" lg="4">
          <v-card class="stat-card-modern cyan-card card-border" elevation="0" rounded="lg">
            <v-card-text class="white--text pa-4">
              <div class="d-flex justify-space-between align-center mb-3">
                <div class="text-body-1 font-weight-medium">Total Order</div>
                <v-icon color="white" size="32">mdi-cash-multiple</v-icon>
              </div>
              <div v-if="process.load" class="d-flex justify-center mb-2">
                <v-progress-circular indeterminate color="white" size="20"></v-progress-circular>
              </div>
              <div v-else>
                <div class="text-h5 font-weight-bold mb-2">Rp {{ formatCurrency(dashboardData.total_order) }}</div>
                <div class="d-flex align-center opacity-90">
                  <v-icon small color="white" class="mr-1" size="16">mdi-information-outline</v-icon>
                  <span class="text-caption">Total Nilai Order</span>
                </div>
              </div>
              <!-- <v-chip small color="rgba(255,255,255,0.2)" text-color="white" class="mt-2">
                <v-icon small left>mdi-arrow-up</v-icon>
                +5.25%
              </v-chip> -->
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" lg="4">
          <v-card class="stat-card-modern purple-card card-border" elevation="0" rounded="lg">
            <v-card-text class="white--text pa-4">
              <div class="d-flex justify-space-between align-center mb-3">
                <div class="text-body-1 font-weight-medium">Jumlah Order</div>
                <v-icon color="white" size="32">mdi-file-document-multiple</v-icon>
              </div>
              <div v-if="process.load" class="d-flex justify-center mb-2">
                <v-progress-circular indeterminate color="white" size="20"></v-progress-circular>
              </div>
              <div v-else>
                <div class="text-h5 font-weight-bold mb-2">{{ dashboardData.jumlah_order }}</div>
                <div class="d-flex align-center opacity-90">
                  <v-icon small color="white" class="mr-1" size="16">mdi-information-outline</v-icon>
                  <span class="text-caption">Jumlah Transaksi</span>
                </div>
              </div>
              <!-- <v-chip small color="rgba(255,255,255,0.2)" text-color="white" class="mt-2">
                <v-icon small left>mdi-arrow-up</v-icon>
                +2.35%
              </v-chip> -->
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" lg="4">
          <v-card class="stat-card-modern pink-card card-border" elevation="0" rounded="lg">
            <v-card-text class="white--text pa-4">
              <div class="d-flex justify-space-between align-center mb-3">
                <div class="text-body-1 font-weight-medium">Total Piutang</div>
                <v-icon color="white" size="32">mdi-credit-card-clock</v-icon>
              </div>
              <div v-if="process.load" class="d-flex justify-center mb-2">
                <v-progress-circular indeterminate color="white" size="20"></v-progress-circular>
              </div>
              <div v-else>
                <div class="text-h5 font-weight-bold mb-2">Rp {{ formatCurrency(dashboardData.total_piutang) }}</div>
                <div class="d-flex align-center opacity-90">
                  <v-icon small color="white" class="mr-1" size="16">mdi-information-outline</v-icon>
                  <span class="text-caption">Piutang Belum Lunas</span>
                </div>
              </div>
              <!-- <v-chip small color="rgba(255,255,255,0.2)" text-color="white" class="mt-2">
                <v-icon small left>mdi-arrow-down</v-icon>
                -12.5%
              </v-chip> -->
            </v-card-text>
          </v-card>
        </v-col>

        <!-- <v-col cols="12" sm="6" lg="3">
          <v-card class="stat-card-modern pink-card card-border" elevation="0" rounded="lg">
            <v-card-text class="white--text pa-4">
              <div class="d-flex justify-space-between align-center mb-3">
                <div class="text-body-1 font-weight-medium">Rata-rata Order</div>
                <v-icon color="white" size="32">mdi-calculator</v-icon>
              </div>
              <div v-if="process.load" class="d-flex justify-center mb-2">
                <v-progress-circular indeterminate color="white" size="20"></v-progress-circular>
              </div>
              <div v-else>
                <div class="text-h5 font-weight-bold mb-2">Rp {{ formatCurrency(calculateAverageOrder()) }}</div>
                <div class="d-flex align-center opacity-90">
                  <v-icon small color="white" class="mr-1" size="16">mdi-information-outline</v-icon>
                  <span class="text-caption">Per Order</span>
                </div>
              </div>
              <v-chip small color="rgba(255,255,255,0.2)" text-color="white" class="mt-2">
                <v-icon small left>mdi-calculator</v-icon>
                Avg
              </v-chip>
            </v-card-text>
          </v-card>
        </v-col> -->
      </v-row>

      <!-- Grafik Monitoring Stock -->
      <v-row class="mb-0">
        <v-col cols="12" md="8">
          <v-card elevation="0" rounded="lg" class="modern-card card-border">
            <v-card-title class="text-subtitle-1 font-weight-bold px-4 pt-4 pb-2">
              Total Visit per Sales
            </v-card-title>
            <v-card-text class="px-4 pb-4">
              <div v-for="(sales, i) in dashboardData.data_sales" :key="i" class="mb-3">
                <div class="d-flex justify-space-between align-center" style="margin-bottom: 6px;">
                  <span class="text-body-2 font-weight-medium">{{ sales.sales_name }}</span>
                  <span class="text-body-2 font-weight-bold">{{ sales.jumlah_visit || 0 }}/{{ sales.jumlah_jadwal || 0 }}</span>
                </div>
          <v-progress-linear
                  :value="calculatePercentage(sales.jumlah_visit, sales.jumlah_jadwal)"
                  :color="getProgressColor(sales.jumlah_visit, sales.jumlah_jadwal)"
            height="8"
            rounded
                ></v-progress-linear>
              </div>
              
              <v-card-text
                v-if="!process.load && dashboardData.data_sales.length === 0"
                class="text-center py-4">
                <div class="text-caption grey--text">Belum ada data</div>
              </v-card-text>
            </v-card-text>
          </v-card>


          <v-card elevation="0" rounded="lg" class="modern-card card-border mt-4">
            <v-card-title class="text-subtitle-1 font-weight-bold px-4 pt-4 pb-2">
              Penjualan per Wilayah (Kecamatan)
            </v-card-title>
            <v-card-text class="px-4 pb-4">
              <apexchart
                v-if="dashboardData.data_penjualan_wilayah.length > 0"
                type="bar"
                height="250"
                :options="regionChartOptions"
                :series="[{
                  name: 'Penjualan',
                  data: dashboardData.data_penjualan_wilayah.map(item => item.total_order)
                }]"
              ></apexchart>
              
              <v-card-text
                v-if="!process.load && dashboardData.data_penjualan_wilayah.length === 0"
                class="text-center py-4">
                <div class="text-caption grey--text">Belum ada data</div>
              </v-card-text>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Total Visit per Sales -->
        <v-col cols="12" md="4">
          <v-card elevation="0" rounded="lg" class="modern-card card-border">
            <div class="fs-16 font-weight-bold px-4 pt-4 pb-2 black--text mb-2">
              Top 5 Customer berdasarkan Nominal Transaksi
            </div>
            <v-card-text class="pa-0">
              <v-list dense class="py-0">
                <v-list-item v-for="(customer, i) in dashboardData.top_customer" :key="i" class="px-4 mb-2">
                  <v-list-item-avatar color="primary" size="32" class="my-2">
                    <span class="white--text text-body-2">{{ i + 1 }}</span>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2 font-weight-medium">
                      <a target="_blank" :href="`/customer/data/detail/${customer.customer_id}`" class="text-decoration-none">
                        {{ customer.customer_name }}
                      </a>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <div class="text-body-2 font-weight-bold primary--text">
                      Rp {{ formatCurrency(customer.total_order) }}
                    </div>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              
              <v-card-text
                v-if="!process.load && dashboardData.top_customer.length === 0"
                class="text-center py-4">
                <div class="text-caption grey--text">Belum ada data</div>
              </v-card-text>
            </v-card-text>
          </v-card>


          <v-card elevation="0" rounded="lg" class="modern-card card-border mt-4">
            <div class="fs-16 font-weight-bold px-4 pt-4 pb-2 black--text mb-2">
              Top 5 Customer berdasarkan Jumlah Order
            </div>
            <v-card-text class="pa-0">
              <v-list dense class="py-0">
                <v-list-item v-for="(customer, i) in dashboardData.top_customer_jumlah_order" :key="i" class="px-4 mb-2">
                  <v-list-item-avatar color="success" size="32" class="my-2">
                    <span class="white--text text-body-2">{{ i + 1 }}</span>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2 font-weight-medium">
                      <a target="_blank" :href="`/customer/data/detail/${customer.customer_id}`" class="text-decoration-none">
                        {{ customer.customer_name }}
                      </a>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <div class="text-body-2 font-weight-bold success--text">
                      {{ customer.jumlah_order }} Order
                    </div>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              
              <v-card-text
                v-if="!process.load && dashboardData.top_customer_jumlah_order.length === 0"
                class="text-center py-4">
                <div class="text-caption grey--text">Belum ada data</div>
              </v-card-text>
            </v-card-text>
          </v-card>

          <v-card elevation="0" rounded="lg" class="modern-card card-border mt-4">
            <div class="fs-16 font-weight-bold px-4 pt-4 pb-2 black--text mb-2">
              Pengiriman Realtime
            </div>
            <v-card-text class="px-4 pb-4 pt-2">
              <div class="d-flex justify-space-around">
                <div class="text-center">
                  <v-avatar color="success" size="64">
                    <v-icon color="white" size="32">mdi-truck-delivery</v-icon>
                  </v-avatar>
                  <div class="text-h5 font-weight-bold mt-2">{{ dashboardData.total_driver_delivery }}</div>
                  <div class="text-caption grey--text">Dalam Pengiriman</div>
                </div>
                <v-divider vertical></v-divider>
                <div class="text-center">
                  <v-avatar color="grey" size="64">
                    <v-icon color="white" size="32">mdi-sleep</v-icon>
                  </v-avatar>
                  <div class="text-h5 font-weight-bold mt-2">{{ dashboardData.total_driver_idle }}</div>
                  <div class="text-caption grey--text">Driver Idle</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card elevation="0" rounded="lg" class="modern-card card-border">
            <v-card-title class="text-subtitle-1 font-weight-bold px-4 pt-4 pb-2">
              Grafik Monitoring Stock
            </v-card-title>
            <v-card-text class="px-4 pb-4">
              <apexchart
                v-if="stock.length > 0"
                type="bar"
                height="250"
                :options="stockChartOptions"
                :series="getStockChartSeries()"
              ></apexchart>
              
              <v-card-text
                v-if="!process.load && stock.length === 0"
                class="text-center py-4">
                <div class="text-caption grey--text">Belum ada data</div>
              </v-card-text>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- 10 Piutang Jatuh Tempo -->
      <v-row>
        <v-col cols="12">
          <v-card elevation="0" rounded="lg" class="modern-card card-border">
            <v-card-title class="text-subtitle-1 font-weight-bold px-4 pt-4 pb-2">
              10 Piutang Masuk Jatuh Tempo
            </v-card-title>
            <v-card-text class="px-0 pb-0">
              <div style="overflow-x: auto; white-space: nowrap;" v-if="piutangJatuhTempo.length > 0 && !process.load">
                <table style="width: 100%; border-collapse: collapse;">
                  <tr style="background: #FAFAFA">
                    <th class="sticky-col-header one-col" style="font-size: 12px; z-index: 2; border: 1px solid #ededed; padding: 10px 12px; width: 180px; min-width: 180px; max-width: 180px; text-align: center; background: #FAFAFA;">
                      Tanggal
                    </th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">
                      No. Piutang
                    </th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">Nama Sales</th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">Nama Spv</th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">Nama Toko</th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: right; padding-left: 30px;">Nilai Piutang</th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">Tgl Bayar</th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: right; padding-left: 30px;">
                      Nilai Bayar
                    </th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: right; padding-left: 30px;">
                      Sisa Piutang
                    </th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">
                      Umur Piutang
                    </th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">Status Invoice</th>
                  </tr>
                  <tr v-for="(item, index) in piutangJatuhTempo" :key="index">
                    <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 180px; min-width: 180px; max-width: 180px; padding: 8px 12px; text-align: center;">
                      {{ formatDate(item.input_datetime) }}
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">
                      <!-- <div class="blue--text" style="cursor: pointer"> -->
                      {{ item.number }}
                      <!-- </div> -->
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">{{ item.sales_name }}</td>
                    <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">
                      {{ item.spv_name }}
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">
                      <a target="_blank" :href="`/customer/data/detail/${item.customer_id}`">
                        {{ item.store_name }}
                      </a>
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: right; padding-left: 30px;">
                      {{ calculateNilaiPiutang(item) | price }}
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">
                      {{ item.paid_date ? formatDateOnly(item.paid_date) : '-' }}
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: right; padding-left: 30px;">
                      <div v-if="!item.paid_date">
                        0
                      </div>
                      <div v-else>
                        {{ calculateNilaiPiutang(item) | price }}
                      </div>
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: right; padding-left: 30px;">
                      <div v-if="!item.paid_date">
                        {{ calculateNilaiPiutangSisa(item) | price }}
                      </div>
                      <div v-else>
                        0
                      </div>
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left;">
                      <div v-if="item.paid_date">
                        {{ calculateUmurPiutang(item.input_datetime, item.paid_date) }} hari
                      </div>
                      <div v-else>
                        {{ calculateUmurPiutang(item.input_datetime) }} hari
                      </div>
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px 12px; width: 1px; white-space: nowrap; text-align: left; text-transform: capitalize;">
                      {{ item.status | status }}
                    </td>
                  </tr>
                </table>
              </div>

              <v-card-text
                v-if="process.load" 
                class="pb-0 my-4" 
                style="height: 300px; display: flex; align-items: center; justify-content: center;">
                <div class="text-center">
                  <div class="mb-4 title">
                    Mohon Tunggu . . .
                  </div>
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </div>
              </v-card-text>

              <v-card-text
                v-if="piutangJatuhTempo.length === 0 && !process.load"
                class="pb-0 my-4" 
                style="height: 300px; display: flex; align-items: center; justify-content: center;">
                <div class="text-center">
                  <v-img 
                    class="mx-auto"
                    contain
                    :width="90"
                    :height="90"
                    :src="require('@/assets/image/empty.png')">
                  </v-img>
                  <div class="mt-3 fs-16">
                    Belum Ada Data
                  </div>
                </div>
              </v-card-text>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Pendapatan per Blok -->
      <!-- <v-row class="mt-4">
        <v-col cols="12">
          <div class="d-flex justify-space-between align-center mb-3">
            <div class="text-h6 font-weight-medium">Pendapatan per Blok</div>
            <a href="#" class="text-decoration-none orange--text">Lihat Semua</a>
          </div>
        </v-col>

        <v-col cols="12" md="4" v-for="(blok, i) in pendapatanBlok" :key="i">
          <v-card elevation="1" rounded="lg">
            <v-card-text>
              <div class="d-flex align-center mb-3">
                <v-avatar :color="blok.color" size="40" class="mr-3">
                  <span class="white--text font-weight-bold">{{ blok.initial }}</span>
                </v-avatar>
                <div>
                  <div class="font-weight-medium">{{ blok.name }}</div>
                  <div class="text-caption grey--text">{{ blok.unit }}</div>
                </div>
              </div>
              
              <apexchart
                type="line"
                height="80"
                :options="getChartOptions(blok.color)"
                :series="blok.series"
              ></apexchart>

              <div class="d-flex justify-space-between align-center mt-3">
                <div class="font-weight-bold">{{ blok.amount }}</div>
                <v-chip small :color="blok.trend > 0 ? 'success' : 'error'" text-color="white">
                  <v-icon small left>{{ blok.trend > 0 ? 'mdi-arrow-up' : 'mdi-arrow-down' }}</v-icon>
                  {{ blok.trendText }}
                </v-chip>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row> -->

      <!-- Biaya Operasional -->
      <!-- <v-row class="mt-4">
        <v-col cols="12">
          <div class="text-h6 font-weight-medium mb-3">Biaya Operasional</div>
        </v-col>

        <v-col cols="12" md="4" v-for="(biaya, i) in biayaOperasional" :key="i">
          <v-card elevation="1" rounded="lg">
            <v-card-text>
              <div class="d-flex align-center mb-3">
                <v-avatar :color="biaya.color" size="40" class="mr-3">
                  <v-icon color="white">{{ biaya.icon }}</v-icon>
                </v-avatar>
                <div>
                  <div class="font-weight-medium">{{ biaya.name }}</div>
                  <div class="text-caption grey--text">{{ biaya.period }}</div>
                </div>
              </div>
              
              <apexchart
                type="line"
                height="80"
                :options="getChartOptions(biaya.color)"
                :series="biaya.series"
              ></apexchart>

              <div class="d-flex justify-space-between align-center mt-3">
                <div class="font-weight-bold">{{ biaya.amount }}</div>
                <v-chip small :color="biaya.trend > 0 ? 'error' : 'success'" text-color="white">
                  <v-icon small left>{{ biaya.trend > 0 ? 'mdi-arrow-up' : 'mdi-arrow-down' }}</v-icon>
                  {{ biaya.trendText }}
                </v-chip>
        </div>
      </v-card-text>
    </v-card>
        </v-col>
      </v-row> -->

      <!-- Laporan Keuangan -->
      <!-- <v-row class="mt-4">
        <v-col cols="12" md="6">
          <v-card elevation="1" rounded="lg">
            <v-card-text>
              <div class="d-flex justify-space-between align-center mb-3">
                <div class="text-h6 font-weight-medium">Laporan Keuangan Bulan Lalu</div>
                <v-icon>mdi-dots-horizontal</v-icon>
              </div>
              <div class="text-caption grey--text mb-0">Lunas pada 27 Juni 2024</div>

              <v-row>
                <v-col cols="4" class="text-center">
                  <div class="text-caption grey--text mb-1">Pendapatan</div>
                  <div class="font-weight-bold">Rp 807.850.000</div>
                </v-col>
                <v-col cols="4" class="text-center">
                  <div class="text-caption grey--text mb-1">Pengeluaran</div>
                  <div class="font-weight-bold">Rp 156.200.000</div>
                </v-col>
                <v-col cols="4" class="text-center">
                  <div class="text-caption grey--text mb-1">Profit</div>
                  <div class="font-weight-bold success--text">Rp 651.650.000</div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card elevation="1" rounded="lg">
            <v-card-text>
              <div class="d-flex justify-space-between align-center mb-3">
                <div class="text-h6 font-weight-medium">Laporan Keuangan Bulan Ini</div>
                <v-icon>mdi-dots-horizontal</v-icon>
              </div>
              <div class="text-caption grey--text mb-0">Harus diselesaikan sebelum 27 Juli 2024</div>

              <v-row>
                <v-col cols="4" class="text-center">
                  <div class="text-caption grey--text mb-1">Pendapatan</div>
                  <div class="font-weight-bold">Rp 850.250.000</div>
                </v-col>
                <v-col cols="4" class="text-center">
                  <div class="text-caption grey--text mb-1">Pengeluaran</div>
                  <div class="font-weight-bold">Rp 168.750.000</div>
                </v-col>
                <v-col cols="4" class="text-center">
                  <div class="text-caption grey--text mb-1">Profit</div>
                  <div class="font-weight-bold success--text">Rp 681.500.000</div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row> -->

      <!-- Transaksi Terbaru -->
      <!-- <v-row class="mt-4">
        <v-col cols="12">
          <v-card elevation="1" rounded="lg">
            <v-card-text>
              <div class="text-h6 font-weight-medium mb-0">Transaksi Terbaru</div>

              <v-data-table
                :headers="headers"
                :items="transaksi"
                :items-per-page="5"
                class="elevation-0"
                hide-default-footer
              >
                <template v-slot:item.status="{ item }">
                  <v-chip
                    small
                    :color="getStatusColor(item.status)"
                    :text-color="getStatusTextColor(item.status)"
                  >
                    {{ item.status }}
                  </v-chip>
                </template>

                <template v-slot:item.jumlah="{ item }">
                  <span class="font-weight-medium">{{ item.jumlah }}</span>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row> -->
      </div>
    </div>
  </div>
</template>

<script>
import { TokenService } from "@/service/Storage.Service";
import { get, post, put, patch, destroy } from "@/service/Axios";
import moment from "moment"
import "moment/locale/id"
  export default {
  components: {
    'date-filter': () => import(/* webpackPrefetch: true */ '@/components/DateFilter.vue')
  },
  filters: {
    price(v) {
      if (!v || v === 0 || v === '0') return '0'
      return Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    status(v) {
      if (v === 'belum lunas') return 'Belum Lunas'
      if (v === 'lunas') return 'Lunas'
      if (v === 'Set Order') return 'Menunggu Pengiriman'
      return v
    }
  },
  data() {
    return {
      // Data untuk Pendapatan per Blok
      pendapatanBlok: [
        {
          initial: 'A',
          name: 'Blok A',
          unit: '50 Unit',
          color: '#2196F3',
          amount: 'Rp 175.500.000',
          trend: 2.1,
          trendText: '+2.1%',
          series: [{
            name: 'Pendapatan',
            data: [150, 170, 145, 175, 160, 180, 165, 185, 170, 175]
          }]
        },
        {
          initial: 'B',
          name: 'Blok B',
          unit: '50 Unit',
          color: '#FFC107',
          amount: 'Rp 168.750.000',
          trend: -1.8,
          trendText: '-1.8%',
          series: [{
            name: 'Pendapatan',
            data: [175, 165, 155, 170, 160, 150, 165, 155, 165, 168]
          }]
        },
        {
          initial: 'C',
          name: 'Blok C',
          unit: '50 Unit',
          color: '#4CAF50',
          amount: 'Rp 182.300.000',
          trend: 3.2,
          trendText: '+3.2%',
          series: [{
            name: 'Pendapatan',
            data: [160, 165, 170, 180, 175, 185, 190, 180, 185, 182]
          }]
        }
      ],

      // Data untuk Biaya Operasional
      biayaOperasional: [
        {
          name: 'Listrik',
          period: 'Bulanan',
          icon: 'mdi-lightning-bolt',
          color: '#FFC107',
          amount: 'Rp 25.500.000',
          trend: 8.5,
          trendText: '+8.5%',
          series: [{
            name: 'Biaya',
            data: [20, 22, 21, 23, 22, 24, 23, 25, 24, 25.5]
          }]
        },
        {
          name: 'Air',
          period: 'Bulanan',
          icon: 'mdi-water',
          color: '#2196F3',
          amount: 'Rp 18.750.000',
          trend: -2.1,
          trendText: '-2.1%',
          series: [{
            name: 'Biaya',
            data: [20, 19, 18.5, 19.5, 19, 18, 18.5, 19, 18.5, 18.75]
          }]
        },
        {
          name: 'Maintenance',
          period: 'Bulanan',
          icon: 'mdi-tools',
          color: '#757575',
          amount: 'Rp 12.300.000',
          trend: 15.2,
          trendText: '+15.2%',
          series: [{
            name: 'Biaya',
            data: [10, 10.5, 11, 10.5, 11.5, 11, 11.5, 12, 11.5, 12.3]
          }]
        }
      ],

      // Headers untuk tabel transaksi
      headers: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'TANGGAL', value: 'tanggal', sortable: false },
        { text: 'PENYEWA', value: 'penyewa', sortable: false },
        { text: 'JUMLAH', value: 'jumlah', sortable: false },
        { text: 'STATUS', value: 'status', sortable: false }
      ],

      start_date: '',
      end_date: '',

      // Data dari API
      dashboardData: {
        jumlah_order: 0,
        total_order: 0,
        total_piutang: 0,
        data_sales: [],
        top_customer: [],
        top_customer_jumlah_order: [],
        total_driver_delivery: 0,
        total_driver_idle: 0,
        data_penjualan_wilayah: []
      },

      stock: [],

      initialLoad: true,

      process: {
        load: false
      },

      // Data untuk Grafik Stock
      stockChartOptions: {
        chart: {
          type: 'bar',
          toolbar: { show: false }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            distributed: false
          }
        },
        colors: ['#2196F3', '#4CAF50', '#FF9800', '#F44336'],
        xaxis: {
          categories: [],
          labels: {
            rotate: -45,
            style: {
              fontSize: '11px'
            }
          }
        },
        yaxis: {
          title: { text: 'Quantity (Dus)' },
          labels: {
            formatter: function(value) {
              if (!value) return '0'
              return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            }
          }
        },
        tooltip: {
          y: {
            formatter: function(value) {
              if (!value) return '0'
              return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' Dus'
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left'
        }
      },

      // Chart Options
      regionChartOptions: {
        chart: {
          type: 'bar',
          toolbar: { show: false }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '50%',
            distributed: true
          }
        },
        colors: ['#2196F3', '#4CAF50', '#FF9800', '#F44336', '#9C27B0', '#00BCD4', '#FFEB3B', '#E91E63', '#9C27B0', '#673AB7'],
        xaxis: {
          categories: []
        },
        yaxis: {
          title: { text: 'Total Penjualan (Rp)' },
          labels: {
            formatter: function(value) {
              if (!value) return '0'
              return 'Rp ' + Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            }
          }
        },
        tooltip: {
          y: {
            formatter: function(value) {
              if (!value) return 'Rp 0'
              return 'Rp ' + Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        }
      },

      // Piutang Jatuh Tempo
      piutangJatuhTempo: [],

      // Data transaksi (dummy untuk sementara)
      transaksi: [
        {
          id: '#001',
          tanggal: '08 Okt 2024',
          penyewa: 'Ahmad Supriadi',
          jumlah: 'Rp 3.500.000',
          status: 'Lunas'
        },
        {
          id: '#002',
          tanggal: '18 Des 2024',
          penyewa: 'Siti Nurhaliza',
          jumlah: 'Rp 3.200.000',
          status: 'Proses'
        },
        {
          id: '#003',
          tanggal: '25 Des 2024',
          penyewa: 'Budi Santoso',
          jumlah: 'Rp 3.800.000',
          status: 'Tunggak'
        }
      ]
    }
  },
    computed: {
    user() {
      return this.$store.state.user
    },
    menu() {
      return this.$store.state.menu
    }
  },
  mounted() {
    this.validateAccess()
  },
  methods: {
    async validateAccess() {
      try {
        // Get menu dari Vuex store atau localStorage
        let menu = this.menu
        
        // Jika tidak ada di store, ambil dari localStorage
        if (!menu) {
          const menuStr = TokenService.getMenu()
          menu = menuStr ? JSON.parse(menuStr) : []
        }
        
        console.log('Menu from localStorage:', menu)
        
        // Cek apakah ada menu dengan id: 122 dan title: 'Dashboard'
        const hasDashboardAccess = menu && Array.isArray(menu) && menu.some(m => 
          m && m.id === 122 && m.title === 'Dashboard'
        )
        
        console.log('Has Dashboard Access:', hasDashboardAccess)
        
        // Jika user memiliki akses ke dashboard
        if (hasDashboardAccess) {
          console.log('Access granted - Loading dashboard...')
          this.initialLoad = false
          
          // Fetch data dashboard
          await Promise.all([
            this.fetch(),
            this.fetchPiutang(),
            this.fetchStock()
          ])
        } else {
          // User tidak memiliki akses dashboard, redirect ke menu pertama
          console.log('Access denied - Redirecting to first menu...')
          console.log('Menu array:', menu)
          
          if (menu && Array.isArray(menu) && menu.length > 0) {
            // Ambil menu pertama dari array
            const firstMenu = menu[0]
            console.log('First menu:', firstMenu)
            
            if (firstMenu && firstMenu.link) {
              console.log('Redirecting to:', firstMenu.link)
              window.location.href = firstMenu.link
            } else {
              // Jika menu pertama tidak ada link, cari menu berikutnya yang punya link
              const menuWithLink = menu.find(m => m && m.link)
              if (menuWithLink && menuWithLink.link) {
                console.log('Redirecting to:', menuWithLink.link)
                window.location.href = menuWithLink.link
              } else {
                console.log('No menu with link found, redirecting to /transactions')
                window.location.href = '/transactions'
              }
            }
          } else {
            // Jika tidak ada menu, redirect ke login
            console.log('No menu found, redirecting to /login')
            window.location.href = '/login'
          }
        }
      } catch (error) {
        console.error('Error validating access:', error)
        // Jika error, redirect ke menu pertama atau login
        try {
          const menuStr = TokenService.getMenu()
          const menu = menuStr ? JSON.parse(menuStr) : []
          
          if (menu && menu.length > 0 && menu[0] && menu[0].link) {
            window.location.href = menu[0].link
          } else {
            window.location.href = '/login'
          }
        } catch (e) {
          window.location.href = '/login'
        }
      }
    },
     async fetch () {
       this.process.load = true

       let params = {
         start_date: this.start_date,
         end_date: this.end_date
       }
       
       await get(`admin/dashboard/total`, { params })
       .then(response => {
         let res = response.data
         
         this.process.load = false
         
         if (res.status === 200) {
           const data = res.results
           
           // Set data ke dashboardData
           this.dashboardData = {
             jumlah_order: data.jumlah_order || 0,
             total_order: data.total_order || 0,
             total_piutang: data.total_piutang || 0,
             data_sales: (data.data_sales || []).filter(item => item && item.sales_name), // Filter empty items
             top_customer: data.top_customer || [],
             top_customer_jumlah_order: data.top_customer_jumlah_order || [],
             total_driver_delivery: data.total_driver_delivery || 0,
             total_driver_idle: data.total_driver_idle || 0,
             data_penjualan_wilayah: data.data_penjualan_wilayah || []
           }
           
           // Update chart data untuk penjualan wilayah
           if (this.dashboardData.data_penjualan_wilayah.length > 0) {
             this.regionChartOptions = {
               ...this.regionChartOptions,
               xaxis: {
                 categories: this.dashboardData.data_penjualan_wilayah.map(item => item.subdistrict_name)
               }
             }
           }
         }
       })
       .catch(error => {
         console.error('Error fetching dashboard data:', error)
         this.process.load = false
       })
     },

    async fetchPiutang () {
      this.process.load = true

      let params = {
        sort: '-id',
        status: 'belum lunas',
        limit: 10
      }

      if (this.start_date && this.end_date) {
        params['due_date[gte]'] = this.start_date
        params['due_date[lte]'] = this.end_date
      }
      
      await get(`admin/customer_invoice/data`, { params })
      .then(response => {
        let res = response.data
        
        this.process.load = false
        
        if (res.status === 200) {
          this.piutangJatuhTempo = res.results.data || []
        }
      })
      .catch(error => {
        console.error('Error fetching piutang data:', error)
        this.process.load = false
      })
    },
     async fetchStock () {
       this.process.load = true

       let params = {
         limit: 10,
         sort: '-saldo'
       }

       if (this.start_date && this.end_date) {
         params['created_at[gte]'] = this.start_date
         params['created_at[lte]'] = this.end_date
       }
       
       await get(`admin/item_stock/data`, { params })
       .then(response => {
         let res = response.data
         
         this.process.load = false
         
         if (res.status === 200) {
           this.stock = res.results.data || []
           
           // Update chart categories
           if (this.stock.length > 0) {
             this.stockChartOptions = {
               ...this.stockChartOptions,
               xaxis: {
                 ...this.stockChartOptions.xaxis,
                 categories: this.stock.map(item => item.varian_name)
               }
             }
           }
         }
       })
       .catch(error => {
         console.error('Error fetching stock data:', error)
         this.process.load = false
       })
     },
    handleDateChange(dateRange) {
      console.log('Date range changed:', dateRange)
      
      if (dateRange.start && dateRange.end) {
        this.start_date = dateRange.start.format('YYYY-MM-DD')
        this.end_date = dateRange.end.format('YYYY-MM-DD')
      } else {
        this.start_date = ''
        this.end_date = ''
      }
      
      // Fetch data dengan filter tanggal baru
      this.fetch()
      this.fetchPiutang()
      this.fetchStock()
    },
    formatCurrency(value) {
      if (!value) return '0'
      return Number(value).toLocaleString('id-ID')
    },
    calculateAverageOrder() {
      if (!this.dashboardData.total_order || !this.dashboardData.jumlah_order || this.dashboardData.jumlah_order == 0) {
        return 0
      }
      return this.dashboardData.total_order / this.dashboardData.jumlah_order
    },
    getChartOptions(color) {
      return {
        chart: {
          type: 'line',
          sparkline: {
            enabled: true
          },
          toolbar: {
            show: false
          }
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        colors: [color],
        tooltip: {
          enabled: false
        }
      }
    },
    getStatusColor(status) {
      if (status === 'Lunas') return '#E8F5E9'
      if (status === 'Proses') return '#E3F2FD'
      if (status === 'Tunggak') return '#FFEBEE'
      return 'grey lighten-3'
    },
    getStatusTextColor(status) {
      if (status === 'Lunas') return '#4CAF50'
      if (status === 'Proses') return '#2196F3'
      if (status === 'Tunggak') return '#F44336'
      return 'grey darken-2'
    },
    getSisaHariColor(hari) {
      if (hari <= 3) return '#FFEBEE'
      if (hari <= 7) return '#FFF3E0'
      return '#E8F5E9'
    },
    getSisaHariTextColor(hari) {
      if (hari <= 3) return '#F44336'
      if (hari <= 7) return '#FF9800'
      return '#4CAF50'
    },
    formatDate(datetime) {
      if (!datetime) return '-'
      return moment(datetime).format('DD MMM YYYY HH:mm')
    },
    formatDateOnly(date) {
      if (!date) return '-'
      return moment(date).format('DD MMM YYYY')
    },
    calculateNilaiPiutang(item) {
      if (!item.orders_detail || item.orders_detail.length === 0) return 0
      
      const totalNilai = item.orders_detail.reduce((sum, k) => {
        return sum + (Math.round((k.price_per_pcs * 1) * (k.total_in_dus * 1)) * (k.qty_dus_diterima * 1))
      }, 0)
      
      const totalDiscount = item.orders_detail.reduce((sum, i) => {
        return sum + (i.discount * 1)
      }, 0)
      
      const totalStrata = item.orders_detail.reduce((sum, i) => {
        return sum + ((i.strata_nominal * 1) * (i.qty_dus_diterima * 1))
      }, 0)
      // console.log(item)
      return totalNilai - totalDiscount - totalStrata
    },
    calculateNilaiPiutangSisa(item) {
      if (!item.orders_detail || item.orders_detail.length === 0) return 0
      
      const totalNilai = item.orders_detail.reduce((sum, k) => {
        return sum + (Math.round((k.price_per_pcs * 1) * (k.total_in_dus * 1)) * (k.qty_dus_diterima * 1))
      }, 0)
      
      const totalDiscount = item.orders_detail.reduce((sum, i) => {
        return sum + (i.discount * 1)
      }, 0)
      
      const totalStrata = item.orders_detail.reduce((sum, i) => {
        return sum + ((i.strata_nominal * 1) * (i.qty_dus_diterima * 1))
      }, 0)
      // console.log(item)
      return totalNilai - totalDiscount - totalStrata - (item.total_paid*1)
    },
    calculateUmurPiutang(inputDate, paidDate = null) {
      if (!inputDate) return 0
      
      const startDate = new Date(inputDate).setHours(0, 0, 0, 0)
      let endDate
      
      if (paidDate) {
        endDate = new Date(paidDate).setHours(0, 0, 0, 0)
      } else {
        endDate = new Date().setHours(0, 0, 0, 0)
      }
      
      return Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24))
    },
    calculatePercentage(visit, jadwal) {
      if (!jadwal || jadwal === 0) return 0
      if (!visit) return 0
      return (visit / jadwal) * 100
    },
    getProgressColor(visit, jadwal) {
      const percentage = this.calculatePercentage(visit, jadwal)
      if (percentage >= 80) return 'success'
      if (percentage >= 60) return 'warning'
      return 'error'
    },
    getStockChartSeries() {
      if (!this.stock || this.stock.length === 0) return []
      
      return [
        {
          name: 'Saldo',
          data: this.stock.map(item => parseFloat(item.saldo) || 0)
        },
        {
          name: 'Persiapan',
          data: this.stock.map(item => parseFloat(item.stock_in_persiapan) || 0)
        },
        {
          name: 'Pengiriman',
          data: this.stock.map(item => parseFloat(item.stock_in_pengiriman) || 0)
        },
        {
          name: 'Diterima',
          data: this.stock.map(item => parseFloat(item.stock_in_diterima) || 0)
        }
      ]
    }
    }
  }
</script>

<style scoped>
.card-border {
  border: 1px solid #E5E7EB !important;
}

.stat-card-modern {
  position: relative;
  overflow: hidden;
  border-radius: 12px !important;
  transition: border-color 0.3s ease;
}

.stat-card-modern:hover {
  border-color: #D1D5DB !important;
}

.cyan-card {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%) !important;
}

.purple-card {
  background: linear-gradient(135deg, #a855f7 0%, #9333ea 100%) !important;
}

.blue-card {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
}

.pink-card {
  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%) !important;
}

.modern-card {
  border-radius: 12px !important;
  overflow: hidden;
  transition: border-color 0.3s ease;
}

.modern-card:hover {
  border-color: #D1D5DB !important;
}

.opacity-90 {
  opacity: 0.9;
}

.v-data-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}

.v-data-table >>> thead {
  background-color: #FAFAFA;
}

.v-data-table >>> thead th {
  font-weight: 600 !important;
  font-size: 13px !important;
  color: #475569 !important;
  letter-spacing: 0.5px !important;
  text-transform: uppercase;
  border-bottom: 1px solid #E5E7EB !important;
}

.v-data-table >>> tbody td {
  font-size: 14px !important;
  color: #334155 !important;
  border-bottom: 1px solid #F3F4F6 !important;
}

.v-data-table >>> tbody tr:hover {
  background-color: #F9FAFB !important;
}

.v-list-item {
  border-bottom: 1px solid #F3F4F6 !important;
}

.v-list-item:last-child {
  border-bottom: none !important;
}

.v-progress-linear {
  border-radius: 8px !important;
}

.v-card-title {
  color: #1e293b !important;
}

/* Sticky column for table */
.sticky-col {
  position: sticky;
  left: 0;
  z-index: 1;
  background: white;
}

.sticky-col-header {
  position: sticky;
  left: 0;
  z-index: 2;
}

.one-col {
  border-left: 1px solid #ededed !important;
}
</style>
